module.exports = __webpack_public_path__ + "static/media/bannerTablet@1x.bbd303bc.jpg";